import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './angular-material.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CoreModule } from './_core/core.module';

import * as Sentry from '@sentry/angular-ivy';
import { Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterComponent } from "./shared/components/footer/footer.component";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { DateFnsAdapter, MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';
import { enUS, zhCN } from 'date-fns/locale';
import { CacheInterceptor } from './_core/interceptors/data-source-cache.interceptor';
import { RequestGroupingInterceptor } from './_core/interceptors/request-grouping.interceptor';
import { provideTippyLoader, provideTippyConfig, tooltipVariation, popperVariation } from '@ngneat/helipopper/config';
import { DynamicContentPageComponent } from './pages/dynamic-content-page/dynamic-content-page.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ContentSectionModule } from './_core/state/content-section/content-section.module';
import { SharedModule } from './shared/shared.module';


@NgModule({
	declarations: [
		AppComponent,
		DynamicContentPageComponent,
		NotFoundComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		AngularMaterialModule,
		HttpClientModule,
		CoreModule,
		FormsModule,
		ReactiveFormsModule,
		FooterComponent,
		ContentSectionModule,
		SharedModule
	],
	providers: [
		provideTippyLoader(() => import('tippy.js')),
		provideTippyConfig({
			defaultVariation: 'tooltip',
			variations: {
				tooltip: tooltipVariation,
				popper: popperVariation
			}
		}),
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler({
				showDialog: false
			})
		},
		{
			provide: Sentry.TraceService,
			deps: [Router]
		},
		{
			provide: APP_INITIALIZER,
			useFactory: () => () => {},
			deps: [Sentry.TraceService],
			multi: true
		},
		{
			provide: MAT_DATE_LOCALE, useValue: "zn-CH"
		},
		{
			provide: DateAdapter,
			useClass: DateFnsAdapter,
			deps: [MAT_DATE_LOCALE]
		},
		{
			provide: MAT_DATE_FORMATS,
			useValue: MAT_DATE_FNS_FORMATS
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: RequestGroupingInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: CacheInterceptor,
			multi: true,
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
